import React from 'react';

const Download = () => {
  return (
    <div>
      Download
      Download
    </div>
  );
}

export default Download;
